import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, toRaw, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import TabsConversion from '@/components/TabsConversion'
import ApplyRecord from './components/ApplyRecord.vue'
import ClueAssign from '../components/ClueAssign.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ConcatModal from '@/components/TabsContacts/ofbu/editModal.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import { clueTypeEnum } from '@/views/overseasSales/clueManage/dataConfig'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuSalesClueView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const permissionFollow = {
  edit: 'ofbu_clue_follow_edit_btn',
  del: 'ofbu_clue_follow_del_btn',
  comment: 'ofbu_clue_follow_comment_btn'
}
const permissionConcat = {
  add: 'ofbu_clue_contact_add_btn',
  edit: 'ofbu_clue_contact_edit_btn',
  del: 'ofbu_clue_contact_del_btn'
}

const queryClueId = computed(() => route.query.clueId as string)
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
const clueTypeComputed = computed(() => {
  const find = clueTypeEnum.find((item) => item.value === dataForm?.clueType)
  if (find?.lang) {
    return t(find.lang)
  }
  return find?.label
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})

const getDetails = () => {
  salesClueDetail({ clueId: queryClueId.value }).then((res) => {
    if (res.data.remindFlag === true) {
      res.data.remindFlag = 1
    } else if (res.data.remindFlag === false) {
      res.data.remindFlag = 0
    } else {
      res.data.remindFlag = undefined
    }
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => getDetails())

const activeTabs = ref('info')
const operationLogRef = ref()
const handleTabsChange = (val: any) => {
  if (val === 'info') {
    getDetails()
  } else if (val === 'logs') {
    operationLogRef.value?.fetch()
  }
}
const goToEdit = () => {
  router.push({ path: '/ofbu/salesClue/edit', query: { clueId: queryClueId.value } })
}
// 新增联系人
const contactsRef = ref()
const concatModalRef = ref()
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successAddConcat = (type: any) => {
  contactsRef.value?.refresh(type)
  operationLogRef.value?.fetch()
  getDetails()
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  const data = [toRaw(dataForm)]
  clueAssignRef.value?.init(data)
}
const handleAssignPersonSuccess = (follower: string) => {
  getDetails()
  dataForm.follower = follower
}

// 跳转跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: queryClueId.value }
  })
}

// // 转潜在客户
// const handleTurnPotential = () => {
//   if (dataForm.clueType === 3) return message.warning(t('tips.TSAOjPMnA'))
//   if (dataForm.dataIntegrity !== 100) {
//     AModal.confirm({
//       title: t('tips.Tvsfe9j3Z'),
//       content: t('tips.NtJGazd'),
//       okText: t('btn.complete'),
//       onOk() {
//         router.push({ path: '/ofbu/salesClue/edit', query: { clueId: dataForm.clueId, isPerfect: 'required' } })
//       },
//       // eslint-disable-next-line @typescript-eslint/no-empty-function
//       onCancel() {}
//     })
//   } else {
//     router.push({
//       path: '/ofbu/business/add',
//       query: { saleChanceRefId: dataForm.clueId, isFromPotentialCustomer: 1 }
//     })
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_CosViewContent, {
              header: "",
              title: dataForm?.customerName,
              sellerName: dataForm?.followerName,
              customLabel: _unref(t)('clue.clueType'),
              customValue: clueTypeComputed.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tabs, {
                  activeKey: activeTabs.value,
                  "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                  onChange: handleTabsChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "info",
                      tab: _unref(t)('common.baseTabs')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(DetailForm, {
                          ref: "detailFormRef",
                          type: "view",
                          isEdit: false,
                          value: dataForm,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event))
                        }, null, 8, ["value"]),
                        (_unref(route).query.isApplay === '1')
                          ? (_openBlock(), _createBlock(ApplyRecord, {
                              key: 0,
                              title: _unref(t)('common.applayTitle')
                            }, null, 8, ["title"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["tab"]),
                    _createVNode(_component_a_tab_pane, {
                      key: "contact",
                      tab: _unref(t)('common.concatTabs')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TabsContacts, {
                          ref_key: "contactsRef",
                          ref: contactsRef,
                          appId: "cos_ofbu",
                          contactRefId: queryClueId.value,
                          permissionPage: permissionConcat
                        }, null, 8, ["contactRefId"])
                      ]),
                      _: 1
                    }, 8, ["tab"]),
                    _createVNode(_component_a_tab_pane, {
                      key: "record",
                      tab: _unref(t)('common.followTabs')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsClueCosFollowUp), {
                          permissionPage: permissionFollow,
                          appId: "cos_ofbu",
                          followRefId: queryClueId.value
                        }, null, 8, ["followRefId"])
                      ]),
                      _: 1
                    }, 8, ["tab"]),
                    _createVNode(_component_a_tab_pane, {
                      key: "convert",
                      tab: _unref(t)('common.conversionTabs')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsConversion), {
                          resourceId: queryClueId.value,
                          appId: "cos_ofbu"
                        }, null, 8, ["resourceId"])
                      ]),
                      _: 1
                    }, 8, ["tab"]),
                    _createVNode(_component_a_tab_pane, {
                      key: "logs",
                      tab: _unref(t)('common.operationLogTabs')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TabsOperationLog, {
                          ref_key: "operationLogRef",
                          ref: operationLogRef,
                          appId: "cos_ofbu",
                          resourceId: queryClueId.value,
                          tableId: "FbuSalesClueOperationLog"
                        }, null, 8, ["resourceId"])
                      ]),
                      _: 1
                    }, 8, ["tab"])
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _: 1
            }, 8, ["title", "sellerName", "customLabel", "customValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_cos_footer_button, { hideOk: true }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleAddConcat()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.addContact')), 1)
              ]),
              _: 1
            })), [
              [_directive_permission, permissionConcat.add]
            ]),
            (!isPublicClue.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                    controlType: "none",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (goToEdit()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'ofbu_clue_edit_btn']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleAssignPerson()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.personClue')), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'ofbu_clue_person_btn']
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (!isPublicClue.value)
              ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (handleWriteFollowUp()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.writeFollow')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_write_follow_btn']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: handleAssignPersonSuccess
    }, null, 512),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: successAddConcat,
      contactRefId: queryClueId.value
    }, null, 8, ["contactRefId"])
  ], 64))
}
}

})